import { Skeleton } from "antd";

import { BTCard } from "commonComponents/btWrappers/BTCard/BTCard";

import "./PlansCardSkeleton.less";

interface IPlansCardSkeletonProps {
    "data-testid"?: string;
}

export function PlansCardSkeleton({
    "data-testid": dataTestId = "plansCardSkeleton",
}: Readonly<IPlansCardSkeletonProps>) {
    return (
        <BTCard
            className="PlansCardSkeleton"
            data-testid={dataTestId}
            aria-busy="true"
            cover={
                <Skeleton
                    active
                    paragraph={false}
                    title={{ width: "calc(100% - 24px)", style: { margin: 12, height: 176 } }}
                />
            }
            bodyStyle={{ padding: 8 }}
        >
            <div className="PlansCardSkeletonBody">
                <Skeleton
                    active
                    paragraph={false}
                    title={{ width: "90%", style: { margin: 0, height: 20 } }}
                />
            </div>
        </BTCard>
    );
}
